import { LinhaVenda } from '@shared/models';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { VendasService } from '@core/services/vendas.service';
import { HistoricModalDetails } from './historic-sales-modal.models'
import { RetornoGetHistoricoFaturamento } from '@core/services/vendas.interface';
import { ConsultRequest } from '@shared/utils/consult-request';

@Component({
  selector: 'app-historic-sales-modal',
  templateUrl: './historic-sales-modal.component.html',
  styleUrls: ['./historic-sales-modal.component.css']
})
export class HistoricSalesModalComponent implements OnInit {
  @ViewChild('historicoFaturamentoModal', {static: true}) historicoFaturamentoModalComponent: ModalComponent;

  historicRequest = new ConsultRequest<RetornoGetHistoricoFaturamento>()
  year: number;
  linhaSelecionada: LinhaVenda;
  label: string = '';

  historicModalDetails: HistoricModalDetails = {
    cliente: null,
    linhas: [],
    type: null,
    ano: null
  };

  constructor(
    private vendasService: VendasService,
  ) { }

  ngOnInit() {
  }

  public open(historicModalDetails: HistoricModalDetails){
    this.historicModalDetails = historicModalDetails;
    this.linhaSelecionada = this.historicModalDetails.linhas[0]
    this.getHistoric()

    this.historicoFaturamentoModalComponent.open()
  }

  handleHistoricComboModalChange(){
    this.getHistoric()
  }

  private getHistoric(){
    const {cliente, ano, type} = this.historicModalDetails;

    const params = {
      idCliente: cliente.idCliente,
      linhasIds: this.linhaSelecionada.linhas,
      ano
    }

    switch(type){
      case 'faturamento':
        this.historicRequest.get(
          this.vendasService.getHistoricoFaturamento(params)
        )
        this.label = 'Faturamento';
        break;
      case 'previsaoVendas':
        this.historicRequest.get(
          this.vendasService.getHistoricoPrevisaoVendas(params)
        )
        this.label = 'Previsão de Vendas';
        break;
      case 'vendas':
        this.historicRequest.get(
          this.vendasService.getHistoricoVendas(params)
        )
        this.label = 'Vendas';
        break;
    }
  }

}
